import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { ConsultaCasosDeUsoComponent } from "../consulta-casos-de-uso/consulta-casos-de-uso.component";
import { CasoDeUsoBean } from "src/app/shared/casosDeUso";
import { ModalSprintComponent } from "../modal-sprint/modal-sprint.component";
import { HistoriaDeUsuario } from "src/app/shared/historiaUsuario";
import { HucuService } from "../hucu.service";
import { TareaHuCu } from "src/app/shared/model/gestion-proyectos/tareasCuHu";

@Component({
  selector: "app-consulta-epicas",
  templateUrl: "./consulta-epicas.component.html",
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class ConsultaEpicasComponent {
  @Input() id!: number;
  @Output() regresar = new EventEmitter<boolean>();

  listEpicas: Array<any> = [];
  consultaObject = new ConsultaList<CasoDeUsoBean>();
  consultaTareas = new ConsultaList<TareaHuCu>();
  tipoSeleccionado: string | null = null;
  listaCu: Array<CasoDeUsoBean> = [];
  listaHu: Array<HistoriaDeUsuario> = [];
  filtroSeleccionado: string | null = null;
  filtlroSeleccionadoTareas: number | null = null;
  idTipoTarea: number | null = null;
  tipoTarea: string | null = null;
  totalRegistros = 0;
  currentPage = 1;
  pageSize = 5;
  readonly pageSizeOptions = [5, 10, 20];
  loading = false;

  constructor(
    private dialog: MatDialog,
    private service: ProyectosService,
    private msg: Msg,
    private hucuService: HucuService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (!this.id) {
      return;
    }
    this.consultaCasosDUso(this.id.toString());
    this.consultaHuXProyecto(this.id.toString());
    this.consultaPagina(1);
  }

  consultaPagina(page = 1): void {
    this.currentPage = Math.max(page, 1);
    this.loading = this.listEpicas.length === 0;
    this.cdr.detectChanges();

    if (this.hasTaskFilter) {
      this.consultaTareas.regInicial = (this.currentPage - 1) * this.pageSize;
      this.consultaTareas.regXPagina = this.pageSize;
      this.consultaTareas.bean = this.consultaTareas.bean ?? new TareaHuCu();
      this.consultaTareas.bean.idtipo = this.idTipoTarea!;
      this.consultaTareas.bean.tipo = this.tipoTarea ?? undefined;

      this.hucuService
        .consultaTareaXTipo(this.consultaTareas)
        .pipe(
          finalize(() => {
            this.loading = false;
            this.cdr.detectChanges();
          }),
        )
        .subscribe({
          next: (res) => this.applyPageResponse(res),
          error: () => {
            this.listEpicas = [];
            this.totalRegistros = 0;
            this.msg.warningCall("Error al consultar datos", null, null);
          },
        });
      return;
    }

    this.consultaObject.regInicial = (this.currentPage - 1) * this.pageSize;
    this.consultaObject.regXPagina = this.pageSize;
    this.consultaObject.bean = new CasoDeUsoBean();
    this.consultaObject.bean.id_proyecto = this.id.toString();
    this.consultaObject.param1 = this.filtroSeleccionado ?? undefined;
    this.consultaObject.sort = "id";
    this.consultaObject.param4 = Constantes.UNO;

    this.service
      .consultaEpicassPaginacion(this.consultaObject)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (res) => this.applyPageResponse(res),
        error: () => {
          this.listEpicas = [];
          this.totalRegistros = 0;
          this.msg.warningCall("Error al consultar datos", null, null);
        },
      });
  }

  filtroChanged(event: MatSelectChange): void {
    this.filtroSeleccionado = event.value ?? null;
    this.filtlroSeleccionadoTareas = null;
    this.idTipoTarea = null;
    this.tipoTarea = null;
    this.consultaPagina(1);
  }

  filtroTareaCu(event: MatSelectChange, tipo: string): void {
    this.filtlroSeleccionadoTareas = event.value != null ? Number(event.value) : null;
    this.idTipoTarea = event.value != null ? Number(event.value) : null;
    this.tipoTarea = event.value != null ? tipo : null;
    this.consultaPagina(1);
  }

  limpiaFiltroTareas(): void {
    this.filtlroSeleccionadoTareas = null;
    this.idTipoTarea = null;
    this.tipoTarea = null;
    this.consultaPagina(1);
  }

  clear(): void {
    this.filtroSeleccionado = null;
    this.filtlroSeleccionadoTareas = null;
    this.idTipoTarea = null;
    this.tipoTarea = null;
    this.consultaPagina(1);
  }

  limpiaTodo(): void {
    this.clear();
  }

  seleccionarTipo(event: MatSelectChange): void {
    if (!event?.value) {
      return;
    }

    this.tipoSeleccionado = event.value;
    const dialogRef = this.dialog.open(ConsultaCasosDeUsoComponent, {
      autoFocus: false,
      disableClose: true,
      maxHeight: "calc(100vh - 32px)",
      maxWidth: "calc(100vw - 32px)",
      width: "920px",
      panelClass: "app-standard-dialog",
      backdropClass: "app-standard-dialog-backdrop",
      data: { clase: this.tipoSeleccionado, id_proyecto: this.id.toString() },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.tipoSeleccionado = null;
      this.consultaCasosDUso(this.id.toString());
      this.consultaHuXProyecto(this.id.toString());
      this.consultaPagina(this.currentPage);
    });
  }

  modificar(row: any): void {
    const dialogRef = this.dialog.open(ConsultaCasosDeUsoComponent, {
      autoFocus: false,
      disableClose: true,
      maxHeight: "calc(100vh - 32px)",
      maxWidth: "calc(100vw - 32px)",
      width: "920px",
      panelClass: "app-standard-dialog",
      backdropClass: "app-standard-dialog-backdrop",
      data: { clase: row.clase, id: row.id, row, id_proyecto: this.id.toString() },
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.tipoSeleccionado = null;
      if (res) {
        this.consultaCasosDUso(this.id.toString());
        this.consultaHuXProyecto(this.id.toString());
        this.consultaPagina(this.currentPage);
      }
    });
  }

  modificarTarea(row: any): void {
    const dialogRef = this.dialog.open(ConsultaCasosDeUsoComponent, {
      autoFocus: false,
      disableClose: true,
      maxHeight: "calc(100vh - 32px)",
      maxWidth: "calc(100vw - 32px)",
      width: "920px",
      panelClass: "app-standard-dialog",
      backdropClass: "app-standard-dialog-backdrop",
      data: { clase: "TAREA", id: row.id, row, id_proyecto: this.id.toString() },
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.tipoSeleccionado = null;
      if (res) {
        this.consultaPagina(this.currentPage);
      }
    });
  }

  regresarLista(): void {
    this.regresar.emit(true);
  }

  agregarSprint(id: number): void {
    const dialogRef = this.dialog.open(ModalSprintComponent, {
      autoFocus: false,
      disableClose: true,
      maxHeight: "calc(100vh - 32px)",
      maxWidth: "calc(100vw - 32px)",
      width: "760px",
      panelClass: "app-standard-dialog",
      backdropClass: "app-standard-dialog-backdrop",
      data: { id },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.consultaPagina(this.currentPage);
    });
  }

  consultaCasosDUso(idProyecto: string): void {
    this.hucuService.consultaCuXProyecto(idProyecto).subscribe((res) => {
      this.listaCu = Array.isArray(res?.list) ? res.list : [];
      this.cdr.detectChanges();
    });
  }

  consultaHuXProyecto(idProyecto: string): void {
    this.hucuService.consultaHuXProyecto(idProyecto).subscribe((res) => {
      this.listaHu = Array.isArray(res?.list) ? res.list : [];
      this.cdr.detectChanges();
    });
  }

  onPageSizeChange(value: number): void {
    this.pageSize = Number(value);
    this.consultaPagina(1);
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }
    this.consultaPagina(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get hasTaskFilter(): boolean {
    return Number(this.idTipoTarea) > 0;
  }

  get totalPages(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
  }

  get showPagination(): boolean {
    return this.totalRegistros > 0;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRegistros);
  }

  get showSecondaryFilter(): boolean {
    return this.filtroSeleccionado === "CU" || this.filtroSeleccionado === "HU";
  }

  get secondaryFilterLabel(): string {
    if (this.filtroSeleccionado === "CU") {
      return "Filtrar tareas de caso de uso";
    }
    if (this.filtroSeleccionado === "HU") {
      return "Filtrar tareas de historia de usuario";
    }
    return "Filtrar tareas";
  }

  get secondaryFilterOptions(): Array<{ id: number; nombre: string }> {
    return this.filtroSeleccionado === "CU" ? this.listaCu : this.listaHu;
  }

  getTypeLabel(row: any): string {
    if (this.hasTaskFilter) {
      return row?.tipo ? `Tarea / ${row.tipo}` : "Tarea";
    }

    const clase = row?.clase ?? "Actividad";
    return row?.tipo ? `${clase} / ${row.tipo}` : clase;
  }

  getDateValue(row: any): Date | string | null {
    return row?.fecha_registro ?? row?.fechaRegistro ?? null;
  }

  getResponsableLabel(row: any): string {
    return row?.nombre_responsable || row?.nombreResponsable || "NA";
  }

  getPriorityLabel(row: any): string {
    return row?.prioridad?.toString?.() || "NA";
  }

  getStatusLabel(row: any): string {
    return this.normalizeStatus(row?.estatus);
  }

  getStatusClass(row: any): string {
    const status = this.normalizeStatus(row?.estatus).toUpperCase();

    if (status.includes("INACT") || status.includes("CANCEL") || status.includes("BAJA")) {
      return "is-inactive";
    }

    if (
      status.includes("PEND") ||
      status.includes("PROCESO") ||
      status.includes("PLANE") ||
      status.includes("REVISION") ||
      status.includes("ANALISIS")
    ) {
      return "is-pending";
    }

    if (status.includes("ERROR") || status.includes("RECHAZ")) {
      return "is-danger";
    }

    return "is-active";
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);

    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === "number";
  }

  private applyPageResponse(res: ConsultaList<any>): void {
    this.listEpicas = Array.isArray(res?.list) ? [...res.list] : [];
    this.totalRegistros = this.resolveTotalRegistros(res, this.listEpicas.length);

    const maxPages = this.totalPages;
    if (maxPages > 0 && this.currentPage > maxPages) {
      this.consultaPagina(maxPages);
      return;
    }

    this.cdr.detectChanges();
  }

  private resolveTotalRegistros(response: ConsultaList<any>, currentItems: number): number {
    const responseRecord = response as ConsultaList<any> & Record<string, unknown>;
    const candidates = [
      responseRecord?.pTotalItems,
      responseRecord?.totalItems,
      responseRecord?.totalRegistros,
      responseRecord?.param4,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed >= 0) {
        return parsed;
      }
    }

    if (currentItems === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.pageSize + currentItems;
  }

  private normalizeStatus(status: string | null | undefined): string {
    if (!status) {
      return "Sin estatus";
    }
    return status.replaceAll("_", " ");
  }
}
